<template>
    <div>

        <footer class="md_footer">
            <div class="inner">

                <!-- Logo -->
                <div class="logo-wrap">
                    <SvgLogoAuma />
                </div>

                <!-- Menu -->
                <div class="menu-wrap">
                    <ul class="menu_footer">
                        <MenuLinkListStatic />
                    </ul>
                </div>

                <p class="copy">&copy; 2021 AUMA All rights reserved.</p>

            </div>
        </footer>

    </div>
</template>

<script>
    //Svg
    import SvgLogoAuma from '@/components/EndUser/svg/SvgLogoAuma'
    //LinkList
    import MenuLinkListStatic from '@/components/EndUser/MenuLinkListStatic'
    export default {
        components: {
            //Svg
            SvgLogoAuma,
            //MenuLinkList
            MenuLinkListStatic,
        }
    }
</script>